import { cn } from '@/lib/utils';
import { badmintonAvatarColor, badmintonInitials } from './badmintonUiUtils';

interface BadmintonPlayerAvatarProps {
  name: string;
  avatarUrl?: string;
  colorKey?: string;
  className?: string;
}

export default function BadmintonPlayerAvatar({
  name,
  avatarUrl,
  colorKey,
  className,
}: BadmintonPlayerAvatarProps) {
  if (avatarUrl) {
    return (
      <img src={avatarUrl} alt={name} className={cn('rounded-full object-cover', className)} />
    );
  }
  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-full font-bold',
        badmintonAvatarColor(colorKey ?? name),
        className
      )}
      aria-hidden
    >
      {badmintonInitials(name)}
    </div>
  );
}
